import {MeasureDataType} from "../measure-data-type";

export class ChartSeries {

    public type?: string;

    /**
     * Name of the series
     */
    public name: string;

    /**
     * Data
     */
    public data: number [];

    /**
     * Data labels for display
     */
    public dataLabels: string [];

    /**
     * Data members used for MDX drilling and filtering. They align one for one with the labels
     */
    public dataMembers: string [];

    public dataType: MeasureDataType;

    /**
     * Attribute that the data is for
     */
    public attribute?: string;

    /**
     * Optional axis to attach the data to if there are multiple axes
     */
    public yAxis?: number;

    /**
     * Optional y-axis label (defaults to data type)
     */
    public yLabel?: string;

    /**
     * Optional indicator to de-emphasise data
     */
    public secondary?: boolean;
}
